import JiraIssueCard from "./JiraIssueCard";

export default JiraIssueCard;
